import { CircleDot } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ClipStatusType } from '@/types/status';
import { getStatusColor } from '@/types/status';

interface StatusBadgeProps {
  status: string;
  statusType: ClipStatusType;
  showIcon?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * Badge displaying clip status with contextual color based on status_type
 */
export function StatusBadge({
  status,
  statusType,
  showIcon = true,
  size = 'md',
  className
}: StatusBadgeProps) {
  const sizeClasses = {
    sm: 'px-1.5 py-0.5 text-xs',
    md: 'px-2 py-1 text-xs',
    lg: 'px-3 py-1.5 text-sm'
  };

  const iconSizes = {
    sm: 'h-2.5 w-2.5',
    md: 'h-3 w-3',
    lg: 'h-3.5 w-3.5'
  };

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full font-medium border',
        getStatusColor(status, statusType),
        sizeClasses[size],
        className
      )}
    >
      {showIcon && <CircleDot className={iconSizes[size]} />}
      {status}
    </span>
  );
}
